import React from 'react';
import PropTypes from 'prop-types';
import colors from 'hsl-shared-components/lib/Theme/colors';
import styled from 'styled-components';
import { LAPTOP_BREAKPOINT_IN_PX } from '../../constants';

const BackButtonWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  height: 24px;
  touch-action: manipulation;
  cursor: pointer;
  text-decoration: none;
`;

const Text = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  top: 1px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.02em;
  line-height: 19px;
  color: ${colors.primary.hslBlue};

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    padding-right: 0;
  }
`;

const CrumbTrailStart = ({ text, link }) => (
  <BackButtonWrapper href={link}>
    <Text>{text}</Text>
  </BackButtonWrapper>
);

CrumbTrailStart.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default CrumbTrailStart;
